export const COLUMNS_TOTAL_COUNT = {
  MAX: 4,
  MIN: 1
};
export const COLUMNS_MIN_SELECTED_COUNT = 1;
